import { useMemo } from 'react';
import { Icon, Popup } from 'semantic-ui-react';
import { AGENCIES } from 'constants/constants';
import './carrier-logo.scss';

export default function CarrierLogo({ code }) {
  const logoMap = useMemo(
    () =>
      Object.entries(AGENCIES).reduce((accumulator, [code, data]) => {
        return {
          ...accumulator,
          [code]: {
            internalUrl: data.logo.internal,
            name: data.name,
          },
        };
      }, {}),
    [],
  );

  return (
    <div className="carrier-logo">
      {code && logoMap[code] ? (
        <img src={logoMap[code].internalUrl} alt={logoMap[code].name} />
      ) : (
        <Popup
          className="base-tooltip"
          content={`¡Revisar agencia ${code}!`}
          trigger={
            <div>
              <Icon aria-label="warning" name="warning sign" color="red" />
              <span>{code}</span>
            </div>
          }
        />
      )}
    </div>
  );
}
